import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import media from 'styled-media-query'

// Components
import ReactSwipe from 'react-swipe'
import Link, { navigateTo } from 'gatsby-link'
import Img from 'gatsby-image'



const SliderContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 9vw;
  z-index: 1;

  .react-swipe-container {
    height: 100%;
    // max-width: 800px;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    > div, a {
      height: 100%;
      cursor: url(/i/zoom.png), pointer;

      .gatsby-image-outer-wrapper,
      .gatsby-image-wrapper {
        position: relative;
        height: 100%
      }
    }
  }
`;

const Arrow = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    visibility: hidden;
  }
`;

const ArrowPrev = styled(Arrow)`
  left: 0;
  cursor: url(/i/prev.png), e-resize;

`;
const ArrowNext = styled(Arrow)`
  right: 0;
  cursor: url(/i/next.png), w-resize;
`;

class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: 0
    }
  }

  prev() {
    this.reactSwipe.prev();
  }

  next() {
    this.reactSwipe.next();
  }

  handleSlideChange(index) {
    this.props.onChange(index);
  }

  componentWillMount() {
    const { current } = this.props;
    this.setState({
      current: current
    });
  }

  componentDidMount() {
    const { current } = this.props;
    if (current >= this.reactSwipe.getNumSlides()) {
      this.reactSwipe.slide(0, 0);
    }
  }

  render() {
    return (
      <SliderContainer>
        <ReactSwipe
          ref={reactSwipe => this.reactSwipe = reactSwipe}
          swipeOptions={{
            callback: this.handleSlideChange.bind(this),
            startSlide: this.state.current
          }}>
          {this.props.data.map(({ node }) => {
            const { path, title, cover } = node.frontmatter;
            const { slug } = node.fields;

            return (
              <Link key={slug} to={slug}>
                <Img
                  title={title}
                  sizes={cover.childImageSharp.sizes} />
              </Link>
            );
          })}
        </ReactSwipe>

        <div>
          <ArrowPrev onClick={::this.prev}><p>&#8592;</p></ArrowPrev>
          <ArrowNext onClick={::this.next}><p>&#8594;</p></ArrowNext>
        </div>
      </SliderContainer>
    )
  }
}

export default Slider


// WEBPACK FOOTER //
// ./src/components/Slider/index.js